import { Headers, Http } from '@angular/http';

export const APP_VERSION: string = '0.2.2';

export const URL_FRONT: string = 'https://cdhfm.medicina.ufrj.br';
export const URL_API: string = 'https://api.cdhfm.medicina.ufrj.br';
export const URL_CAS: string = 'https://cas.ufrj.br/';
export const URL_LOGOUT: string = 'https://cdhfm.medicina.ufrj.br/';

export const HEADERS: Headers = new Headers({'Accept': 'application/json; text/plain, */*', 'Content-Type': 'text/plain; application/json'});

export const HEADERS_GET: Headers = new Headers(
  {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Access-Control-Allow-Methods': 'HEAD, GET, POST, PUT, PATCH, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, X-Auth-Token, Origin, Authorization, Auth, X-Request-With',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Origin': '*'
  }
);


// WEBPACK FOOTER //
// ./src/app/constante.ts